module.exports = __webpack_public_path__ + "assets/a6825d48494296250f5f3e8d8fbe6583.png";